document.addEventListener("DOMContentLoaded", function() {
  const lazyVideos = document.querySelectorAll(".lazy-video");

  if ("IntersectionObserver" in window) {
    let videoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let video = entry.target;
          let source = video.querySelector("source");
          source.src = source.getAttribute("data-src");
          video.load(); // Load the video
          video.play(); // Optionally play the video

          videoObserver.unobserve(video); // Stop observing once it's loaded
        }
      });
    });

    lazyVideos.forEach(function(video) {
      videoObserver.observe(video);
    });
  } else {
    // Fallback for browsers without IntersectionObserver support
    lazyVideos.forEach(function(video) {
      let source = video.querySelector("source");
      source.src = source.getAttribute("data-src");
      video.load();
    });
  }
});
